<template>
  <div class="user-settings usrsett large-scroll-track">
    <TabsContentTemplate
      :sections="sections"
      :tab="l_tab"
      @update:tab="handleTabUpdate"
    >
      <template #content_appearance>
        <UserAppearance />
      </template>
      <template #content_analyzer>
        <SettingsAnalyzerV2 class="usrsett_right_item pt-4 mr-auto" />
      </template>
      <template #content_hotkeys>
        <SettingsHotkeys class="usrsett_right_item pt-4" />
      </template>
      <template #content_language>
        <LangSwitcher asBlocks />
      </template>
    </TabsContentTemplate>
  </div>
</template>

<script>
import TabsContentTemplate from '@/components/TabsContentTemplate/TabsContentTemplate'
import SettingsHotkeys from '@/components/Dialogs/UserSettingsDialog/SettingsHotkeys'
import UserAppearance from '@/components/Dialogs/UserSettingsDialog/UserAppearance'
import LangSwitcher from '@/components/LangSwitcher/LangSwitcher'
import SettingsAnalyzerV2 from '@/components/Dialogs/UserSettingsDialog/SettingsAnalyzerV2'

export default {
  name: 'UserSettingsDialog',
  components: {
    TabsContentTemplate,
    SettingsHotkeys,
    UserAppearance,
    LangSwitcher,
    SettingsAnalyzerV2,
  },
  data() {
    return {
      l_tab: 'appearance',
    }
  },
  created() {
    const tab = this.$route.query.settings_tab
    this.l_tab = this.sections.some(i => i.id === tab) ? tab : 'appearance'
  },
  methods: {
    handleTabUpdate(tab) {
      this.$router
        .replace({
          query: {
            ...this.$route.query,
            settings_tab: tab,
          },
        })
        .catch(() => {})
    },
  },
  computed: {
    sections() {
      return [
        {
          id: 'appearance',
          title: this.$t('links.UserAppearance'),
          icon: 'mdi-palette-outline',
        },
        {
          id: 'hotkeys',
          title: this.$t('links.UserHotkeys'),
          icon: 'mdi-keyboard',
        },
        {
          id: 'analyzer',
          title: this.$t('links.HHanalyzer'),
          icon: 'mdi-cogs',
        },
        {
          g1_hide: true,
          id: 'language',
          title: this.$t('links.UserLanguage'),
          icon: 'mdi-earth',
        },
      ].filter(i => (this.mobile ? i.id !== 'hotkeys' : i.g1_hide ? !this.$i18n.g1 : true))
    },
  },
}
</script>

<style lang="scss">
.usrsett {
  display: flex;
  min-height: 0;
  max-height: 42rem;
  min-height: 42rem;
  min-width: 42rem; // overflow-x: hidden;
  // overflow-y: hidden;
  &_right {
    padding: 1rem 0;
    &_item {
      min-height: 0rem;
      display: flex;
      padding: 0 1rem;
      // margin: 0 0 1rem 0;
    }
  }
}
</style>
